import makeStyles from '@mui/styles/makeStyles';

import { divideBy } from '../../../styles/styleUtils';
import type { Theme } from '../../../types';
import { SIDEBAR_MOTION } from '../layoutConstants';

const headerStyles = makeStyles((theme: Theme) => {
    //@ts-ignore
    const spacer = theme.themeVars.spacer;
    return {
        appHeader: {
            //@ts-ignore
            height: theme.themeVars.headerHeight,
            display: 'flex',
            flexDirection: 'row',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1100
        },
        appHeaderToolbar: {
            flex: '1',
            paddingLeft: spacer,
            paddingRight: spacer
        },
        btnToggleCollapse: {
            // The toggle belongs to the toolbar, not to the logo. The old
            // -55px pulled it back over the logo block, so with the sidebar
            // open the hamburger sat on the branding.
            marginLeft: '0',
            paddingRight: '30px',
            // Same motion as the rail itself — this button slides as the logo
            // block resizes, and on a different duration the two read as two
            // animations.
            transition: `margin ${SIDEBAR_MOTION}, padding ${SIDEBAR_MOTION}`,
            [theme.breakpoints.down('lg')]: {
                display: 'none'
            }
        },
        btnToggleCollapseClosed: {
            // Clear of the logo mark. The collapsed block used to be 90px wide,
            // which held the toggle away from it on its own; the rail is 56, so
            // the gap has to be stated rather than inherited — otherwise the
            // hamburger sits right on the mark.
            marginLeft: theme.spacing(3),
            marginRight: spacer,
            paddingRight: '0'
        },
        appLogoImg: {
            width: '28px',
            height: '28px'
        },
        appLogoBtn: {
            padding: divideBy(spacer, 2)
        },
        appLogoLink: {
            textDecoration: 'none',
            [theme.breakpoints.up('lg')]: {
                marginTop: divideBy(spacer, 2)
            },
            [theme.breakpoints.down('xl')]: {
                marginRight: spacer
            }
        },
        appLogoText: {
            fontSize: '16px',
            fontWeight: 'bold',
            width: 'auto',
            display: 'block'
        },
        widthUnset: {
            width: 'unset'
        },
        uppercase: {
            textTransform: 'uppercase'
        }
    };
});
export default headerStyles;
